import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "x_panel"
};
const _hoisted_2 = { class: "x_content" };
const _hoisted_3 = { class: "d-flex justify-content-between" };
const _hoisted_4 = { class: "d-flex" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    class: "list-filter",
    style: { "min-height": "260px", "height": "25vh", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_8 = { class: "list-options" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { style: { "font-weight": "700", "font-size": "16px" } };
const _hoisted_11 = { class: "d-flex justify-content-between" };
const _hoisted_12 = { class: "d-flex" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
    class: "list-filter",
    style: { "min-height": "260px", "height": "25vh", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_16 = { class: "list-options" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { style: { "font-weight": "700", "font-size": "16px" } };
const _hoisted_19 = { class: "" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_b_tabs = _resolveComponent("b-tabs");
    return (!_ctx.loadingContacts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_b_tabs, {
                    modelValue: _ctx.activeTab,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.activeTab) = $event)),
                    "nav-wrapper-class": "x_title tabs",
                    "content-class": "x_content"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_tab, {
                            key: "contacts",
                            title: "Contacts"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[7] || (_cache[7] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tContacts *\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedContactCount()), 1 /* TEXT */),
                                        _cache[5] || (_cache[5] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input ms-3",
                                            style: { "margin-top": "2px" },
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showOnlySelected) = $event)),
                                            disabled: _ctx.selectedContactCount() == 0
                                        }, null, 8 /* PROPS */, _hoisted_5), [
                                            [_vModelCheckbox, _ctx.showOnlySelected]
                                        ]),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        _createElementVNode("label", {
                                            class: "form-check-label",
                                            disabled: _ctx.selectedContactCount() == 0
                                        }, " Show only selected", 8 /* PROPS */, _hoisted_6)
                                    ])
                                ]),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createVNode(_component_b_form_input, {
                                    modelValue: _ctx.contactsFilter,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.contactsFilter) = $event)),
                                    modelModifiers: { trim: true },
                                    placeholder: "Search for..."
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactsFiltered, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(['list-option', _ctx.isContactSelected(item) ? 'selected-option' : '']),
                                                onClick: ($event) => (_ctx.selectContact(item)),
                                                style: { "text-align": "left", "padding": "5px" }
                                            }, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1 /* TEXT */),
                                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                                    _createElementVNode("span", null, " - " + _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                                ])
                                            ], 10 /* CLASS, PROPS */, _hoisted_9));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _cache[19] || (_cache[19] = _createTextVNode()),
                        (_ctx.isUserAllowedToScheduleReportsToOtherUsers)
                            ? (_openBlock(), _createBlock(_component_b_tab, {
                                key: "contactGroups",
                                title: "Contact Groups"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                        _cache[14] || (_cache[14] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tContact Groups\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedContactGroupCount()), 1 /* TEXT */),
                                            _cache[12] || (_cache[12] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input ms-3",
                                                style: { "margin-top": "2px" },
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showOnlyGroupsSelected) = $event)),
                                                disabled: _ctx.selectedContactGroupCount() == 0
                                            }, null, 8 /* PROPS */, _hoisted_13), [
                                                [_vModelCheckbox, _ctx.showOnlyGroupsSelected]
                                            ]),
                                            _cache[13] || (_cache[13] = _createTextVNode()),
                                            _createElementVNode("label", {
                                                class: "form-check-label",
                                                disabled: _ctx.selectedContactGroupCount() == 0
                                            }, " Show only selected", 8 /* PROPS */, _hoisted_14)
                                        ])
                                    ]),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, {
                                        modelValue: _ctx.contactGroupsFilter,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.contactGroupsFilter) = $event)),
                                        modelModifiers: { trim: true },
                                        placeholder: "Search for..."
                                    }, null, 8 /* PROPS */, ["modelValue"]),
                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactGroupsFiltered, (item) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass(['list-option', _ctx.isContactGroupSelected(item) ? 'selected-option' : '']),
                                                    onClick: ($event) => (_ctx.selectContactGroup(item)),
                                                    style: { "text-align": "left", "padding": "5px" }
                                                }, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.description), 1 /* TEXT */)
                                                    ]),
                                                    _cache[16] || (_cache[16] = _createTextVNode()),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getContactNames(item)), 1 /* TEXT */)
                                                    ])
                                                ], 10 /* CLASS, PROPS */, _hoisted_17));
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
